'use client';
import PropTypes from 'prop-types';
import { AllZones } from './AllZones';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import '../split/page.css';

const ZonesPage = ({ userIsAdmin }) => {
  return (
    <TableViewerLayout
      tableTitle='All Zones'
      tableSlot={<AllZones userIsAdmin={userIsAdmin} />}
    />
  );
};

ZonesPage.propTypes = {
  userIsAdmin: PropTypes.bool,
};

export default ZonesPage;
